import Vue from 'vue'
import Contact from './components/Contact'
import api from './assets/api'

// Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  el:'#contact',
  render: function (h) { return h(Contact) },
})//.$mount('#app')
